module.exports = __webpack_public_path__ + "static/img/wait.af88dc4c.png";